import Router from "next/router";
import Image from "next/image";
import ReactMarkdown from "react-markdown";
import Container from "../Container";
import useTranslation from "../../helpers/translationTexts/useTranslation";
import { Content } from "@/types/PropTypes";
import styles from "./PrivacyPolicy.module.scss";

export default function PrivacyPolicy({ content }: Content) {
  return (
    <Container>
      <div className={styles.goBackWrapper}>
        <Image className={styles.goBackArrowIcon} src="/images/arrow-left.svg" alt="arrow left" width={9} height={14} />
        <button className={styles.goBackBtn} onClick={() => Router.back()}>
          {useTranslation("goBack")}
        </button>
      </div>
      <div className={styles.privacyWrapper}>
        <ReactMarkdown>{content}</ReactMarkdown>
      </div>
    </Container>
  );
}
